<ng-container *transloco="let t">
  <mat-sidenav-container class="register-box h-[calc(100vh-86px)] overflow-hidden" [ngClass]="{
      'side-panel-opened': sidePanelOpened(),
      'side-panel-closed': !sidePanelOpened()
    }">

    <mat-sidenav #registernav [mode]="isOver() ? 'over' : 'side'" [opened]="!isOver()"
      (open)="sidePanelOpened.set(true)" (close)="sidePanelOpened.set(false)"
      class="register-sidebar w-70! h-full flex flex-col">
      <div class="py-2 px-3">
        <button mat-flat-button color="primary" class="w-full btn-block" (click)="navigateFiles()">
          {{ t('Files') }}
        </button>
      </div>
      <ng-scrollbar visibility="hover" appearance="compact">
        <div class="p-2">
          <app-feature-filter feature="stored_file"></app-feature-filter>
        </div>
      </ng-scrollbar>
    </mat-sidenav>
    <mat-sidenav-content class="h-full overflow-hidden flex flex-col">

      <div class="h-full overflow-hidden flex-1 min-h-0">
        <div class="grid grid-cols-12 h-full overflow-hidden">

          <div class="col-span-12 lg:col-span-4 p-0 h-full min-h-0 flex flex-col">
            <div class="register-panel-header py-2 px-4 flex flex-col gap-6">
              <div class="flex flex-row items-center gap-4 min-h-10">

                <button (click)="registernav.toggle()" mat-icon-button>
                  <i class="iconify text-2xl opacity-80" data-icon="ic:round-short-text"></i>
                </button>

                <app-search-title class="truncate flex-1" [searchService]="searchService"
                  [title]="t('File Finder')">
                </app-search-title>

                <div class="flex flex-row items-center gap-0.5">
                  <app-search-pagination [searchService]="searchService"></app-search-pagination>

                  <button mat-icon-button (click)="searchService.search().subscribe()">
                    <i class="iconify text-2xl opacity-80" data-icon="solar:refresh-outline"></i>
                  </button>

                  <button mat-icon-button [matMenuTriggerFor]="headerMenu">
                    <i class="iconify text-2xl opacity-80" data-icon="mdi:dots-vertical"></i>
                  </button>
                </div>
                <mat-menu #headerMenu>
                  <button mat-menu-item (click)="navigateFiles()">
                    <div class="flex items-center gap-4">
                      <i class="iconify text-2xl opacity-80" data-icon="solar:folder-linear"></i>
                      <span>{{ t('Files') }}</span>
                    </div>
                  </button>

                  <button mat-menu-item (click)="searchService.search().subscribe()">
                    <div class="flex items-center gap-4">
                      <i class="iconify text-2xl opacity-80" data-icon="solar:refresh-outline"></i>
                      <span>{{ t('Update List') }}</span>
                    </div>
                  </button>
                </mat-menu>

              </div>

              <app-search-input class="w-full" [(ngModel)]="searchService.searchText"
                [working]="searchService.loading()" (update)="searchService.search().subscribe()"
                name="list-search-input">
              </app-search-input>
            </div>

            @if(searchService.items().length){
            <ng-scrollbar class="relative flex-1 min-h-0 register-list-scroll mt-2">
              <div class="flex flex-col p-4 gap-1">
                @for(item of searchService.items(); track item.id) {
                <div (click)="selectItem(item)" [class.bg-light-primary]="item.id == service.model()?.id"
                  class="flex flex-row items-center gap-4 p-2 rounded-md cursor-pointer hover:bg-light hover:bg-opacity-50">

                  <div class="flex items-center justify-center size-10 rounded-full shrink-0 bg-light-primary">
                    <span class="inline-flex"><i class="iconify text-2xl opacity-80"
                      [attr.data-icon]="iconOf(item)"></i></span>
                  </div>

                  <div class="flex flex-col flex-auto gap-1 min-w-0">
                    <h6 class="text-base leading-none font-normal truncate">{{ item.originalName }}</h6>

                    <span class="text-xs leading-none opacity-60 truncate">
                      {{ item.type?.name || item.contentType }}
                      @if(item.code) { · #{{ item.code }} }
                      · {{ formatBytes(item.sizeBytes) }}
                    </span>

                    <span class="text-xs leading-none opacity-60 truncate">
                      {{ item.storage?.name }}
                      @if(item.folder?.name) { · {{ item.folder?.name }} }
                      @if(item.feature?.name) { · {{ item.feature?.name }} }
                      @if(item.parentName) { · {{ item.parentName }} }
                    </span>

                    @if(item.log?.createdAt) {
                    <span class="text-xs opacity-50">{{ t('Uploaded') }} {{ item.log?.createdAt | date:'dd/MM/yyyy HH:mm' }}</span>
                    }
                  </div>

                  <button mat-icon-button [matMenuTriggerFor]="itemMenu" (click)="$event.stopPropagation()">
                    <i class="iconify opacity-50!" data-icon="mdi:dots-vertical"></i>
                  </button>

                  <mat-menu #itemMenu>
                    <button mat-menu-item (click)="selectItem(item)">
                      <div class="flex items-center gap-4">
                        <i class="iconify text-2xl opacity-80" data-icon="solar:eye-linear"></i>
                        <span>{{ t('View') }}</span>
                      </div>
                    </button>

                    @if(service.canDownload(item)) {
                    <button mat-menu-item (click)="download(item, $event)">
                      <div class="flex items-center gap-4">
                        <i class="iconify text-2xl opacity-80" data-icon="solar:download-linear"></i>
                        <span>{{ t('Download') }}</span>
                      </div>
                    </button>
                    }

                    <button mat-menu-item (click)="searchService.search().subscribe()">
                      <div class="flex items-center gap-4">
                        <i class="iconify text-2xl opacity-80" data-icon="solar:refresh-outline"></i>
                        <span>{{ t('Update List') }}</span>
                      </div>
                    </button>
                  </mat-menu>

                </div>
                }
              </div>
            </ng-scrollbar>
            } @else {
            <div class="flex flex-row items-center justify-center w-full py-8">
              <div>{{ t('No registers found.') }}</div>
            </div>
            }
          </div>
          <div class="col-span-12 lg:col-span-8 detail-part p-0 h-full min-h-0 overflow-hidden"
            [class.movetodetail]="service.model() !== null">
            <router-outlet></router-outlet>
            @if(service.model() === null) {
            <div class="flex flex-row items-center justify-center w-full h-full">
              <span class="opacity-50">{{ t('Select a file to see its details.') }}</span>
            </div>
            }
          </div>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</ng-container>
